import {getLocalizationBasedOnLang} from '../../data/models/User/UserInfo';

const english = {
  challengeBranch: 'Challenge branch',
  choiceBranch: 'Choice branch',
  showImage: 'Show image',
  showQuestion: 'Show question',
  selectAll: 'Select all that apply',
  infoGradable: 'This question is assessable',
  infoPercent: 'Score needed to pass',
  total: 'Total',
  viewResults: 'View results',
  back: 'Back',
  retry: 'Retry',
  courseHome: 'Course home',
  continue: 'Continue',
  submitAnswer: 'Submit answer',
  answerExplanation: 'Answer explanation',
  lessonCompleted: 'Lesson completed!',
  nextLesson: 'Next lesson',
  tryAgain: 'Please try again!',
  finalScore: 'Your final score: ',
  wellDone: 'Well done!',
  multipleChoice: 'Multiple choice',
  gradableLesson: 'This is an assessment-based lesson',
  grabableDescription: 'Your answers will count towards your final score.',
  informativeDescription:
    "You're about to start virtual driving - keep an eye out for offers!",
  imReady: "I'm ready",
  informativeLesson: 'Get Ready!',
  hideQuestion: 'Hide question',
  lessonIsEmpty: 'Lesson is empty',
  finish: 'Finish',
  captions: 'Captions',
  on: 'On',
  off: 'Off',
  openEndedQuestion: 'Open-ended question',
};

const welsh = {
  challengeBranch: 'Cangen her',
  choiceBranch: 'Cangen dewis',
  showImage: 'Dangos delwedd',
  showQuestion: 'Dangos cwestiwn',
  selectAll: "Dewiswch bawb sy'n berthnasol",
  infoGradable: "Mae'r cwestiwn hwn yn asesadwy",
  infoPercent: 'Sgôr sydd ei hangen i basio',
  total: 'Cyfanswm',
  viewResults: 'Gweld canlyniadau',
  back: 'Yn ôl',
  retry: 'Ceisio eto',
  courseHome: 'Cartref y cwrs',
  continue: 'Parhewch',
  submitAnswer: 'Cyflwyno ateb',
  answerExplanation: 'Esboniad o’r ateb',
  lessonCompleted: "Gwers wedi'i gorffen!",
  nextLesson: 'Gwers nesaf',
  tryAgain: 'Pleidiwch geisio eto!',
  finalScore: 'Eich sgôr derfynol:',
  wellDone: 'Da iawn!',
  multipleChoice: 'Amlddewis',
  gradableLesson: "Mae hon yn wers wedi'i seilio ar asesiad",
  grabableDescription: 'Bydd eich atebion yn cyfrif tuag at eich sgôr derfynol',
  informativeDescription:
    "Mae'r wers hon dim ond ar gyfer dysgu, heb unrhyw raddio'n gysylltiedig",
  imReady: "Rwy'n barod",
  informativeLesson: 'Gwers wybodaeth',
  hideQuestion: "Cuddio'r cwestiwn",
  lessonIsEmpty: "Mae'r gwers yn wag",
  finish: 'Gorffen',
  captions: 'Capshynau',
  on: 'Ar',
  off: 'I ffwrdd',
  openEndedQuestion: 'Cwestiwn agored',
};

export const tapyblPlayerText: any = getLocalizationBasedOnLang(english, welsh);
